import { getSentryUserId } from "./user";
export const bindDataForSend = (event) => {
    // console.error может прилететь изнутри редьюсера, тогда getState() бросает
    // и событие вместо исходной ошибки превращается в "You may not call store.getState()..."
    try {
        bindUser(event);
        bindConference(event);
    }
    catch (e) {
        // nope
    }
    bindConnectStats(event);
};
const bindUser = (event) => {
    if (!APP.store || !event.extra) {
        return;
    }
    const userId = APP.conference.getMyUserId();
    const { user } = APP.store.getState()['features/base/jwt'] ?? {};
    if (user) {
        event.extra['jwt-user'] = { id: user.id, type: user.type };
        // первое событие может уйти раньше, чем SET_JWT проставит пользователя в scope
        if (!event.user?.id) {
            event.user = { ...event.user, id: getSentryUserId(user) };
        }
    }
    if (userId) {
        event.extra['user'] = { id: userId };
    }
};
const bindConference = (event) => {
    if (!APP.store || !event.extra) {
        return;
    }
    const { conference, error } = APP.store.getState()['features/base/conference'] ?? {};
    event.extra['conference'] = {
        sessionId: conference?.sessionId,
        error,
    };
};
const bindConnectStats = (event) => {
    try {
        // иногда падает, ибо модуль не инициализирован
        const stats = APP.conference.getStats();
        if (!stats || !event.extra) {
            return;
        }
        event.extra['connect-stats'] = {
            bitrate: stats.bitrate,
            packetLoss: stats.packetLoss,
            connectionQuality: stats.connectionQuality,
            connectionState: APP.conference.getConnectionState()
        };
    }
    catch (e) {
        // nope
    }
};
